export {
  type ApolloClient,
  ApolloError,
  ApolloProvider,
  type ApolloQueryResult,
  type BaseMutationOptions,
  InMemoryCache,
  type LazyQueryHookOptions,
  type MutationFunction,
  type MutationHookOptions,
  type MutationResult,
  NetworkStatus,
  type NormalizedCacheObject,
  type Operation,
  type OperationVariables,
  type QueryHookOptions,
  type QueryLazyOptions,
  type QueryResult,
  type SkipToken,
  skipToken,
  type SuspenseQueryHookOptions,
  useApolloClient,
  useLazyQuery,
  useMutation,
  useQuery,
  useSuspenseQuery,
  type UseSuspenseQueryResult,
} from '@apollo/client';
export type {ExecutionResult} from 'graphql';

// As of Feb 2024, query dedupe is much more impactful from a performance perspective than query abort.
// We're disabling query dedupe for now, but we may want to re-enable it in the future.
// It must be disabled in order to enable Apollo's internal query dedupe, since aborting inflight queries
// with query dedupe enabled causes Apollo to never fire the query again, even on remount.

// We wrap Apollo's `useQuery` in logic which aborts the query when the component unmounts.
// Apollo uses `fetch` under the hood, which is cancellable via `AbortController`.
// See https://developer.mozilla.org/en-US/docs/Web/API/AbortController.
// export const useQuery: typeof useApolloQuery = (document, options = {}) => {
//   // This `useMemo` is required so we only create one `AbortController` on mount.
//   const controller = useMemo(() => new AbortController(), []);
//   // This only runs once on component unmount.
//   useEffect(() => () => controller.abort(), [controller]);

//   // Preserve passed in options while populating `options.context.fetchOptions.signal`.
//   const optionsWithSignal = produce(options, draft => {
//     draft.context = draft.context ?? {};
//     draft.context.fetchOptions = draft.context.fetchOptions ?? {};
//     draft.context.fetchOptions.signal = controller.signal;
//   });

//   return useApolloQuery(document, optionsWithSignal);
// };
